"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsModelBase = void 0;
var tslib_1 = require("tslib");
var Sentry = tslib_1.__importStar(require("@sentry/browser"));
var inversify_1 = require("inversify");
var utils_1 = require("@dp-instant/utils");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var urlRequest = function (url, payload) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var rawResponse, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4, fetch(url, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(payload)
                    })];
            case 1:
                rawResponse = _a.sent();
                return [4, rawResponse.json()];
            case 2: return [2, _a.sent()];
            case 3:
                e_1 = _a.sent();
                utils_1.log.warn(e_1);
                return [3, 4];
            case 4: return [2, {}];
        }
    });
}); };
var PaymentsModelBase = (function () {
    function PaymentsModelBase() {
    }
    PaymentsModelBase.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2];
            });
        });
    };
    PaymentsModelBase.prototype.getById = function (id) {
        return;
    };
    PaymentsModelBase.prototype.getAll = function () {
        return [];
    };
    PaymentsModelBase.prototype.isPaid = function (id) {
        return false;
    };
    PaymentsModelBase.prototype.consume = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, false];
            });
        });
    };
    PaymentsModelBase.prototype.purchase = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, false];
            });
        });
    };
    PaymentsModelBase.prototype.buy = function (id, consume) {
        if (consume === void 0) { consume = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                throw new Error("Method not implemented.");
            });
        });
    };
    Object.defineProperty(PaymentsModelBase.prototype, "supported", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    PaymentsModelBase.prototype.validateRemotely = function (url, purchaseMade) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status, response, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, urlRequest(url, purchaseMade)];
                    case 2:
                        response = _a.sent();
                        this.trackPurchase("validate", response.success);
                        status = !!response.success;
                        return [3, 4];
                    case 3:
                        e_2 = _a.sent();
                        Sentry.captureException(e_2);
                        return [3, 4];
                    case 4: return [2, status];
                }
            });
        });
    };
    PaymentsModelBase.prototype.viewItems = function (ids) {
        utils_1.log.warn("viewItems not implemented");
    };
    PaymentsModelBase.prototype.trackEcommerce = function (eventName, payload) {
        this.trackEvent(eventName, {
            currency: payload.currency,
            value: payload.value,
            items: [{ item_id: payload.item_id, item_name: payload.item_id, price: payload.value }]
        });
    };
    PaymentsModelBase.prototype.trackPurchase = function (eventName, params) {
        this.trackEvent(eventName, params, 1, "purchase_");
    };
    PaymentsModelBase.prototype.trackEvent = function (eventName, params, value, prefix) {
        var _a;
        if (value === void 0) { value = 1; }
        if (prefix === void 0) { prefix = ""; }
        (_a = (0, core_1.lazyGet)(interfaces_1.TypesAnalytics.tracker)) === null || _a === void 0 ? void 0 : _a.track("".concat(prefix).concat(eventName), value, params);
    };
    PaymentsModelBase = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], PaymentsModelBase);
    return PaymentsModelBase;
}());
exports.PaymentsModelBase = PaymentsModelBase;
//# sourceMappingURL=PaymentsModelBase.js.map